<div dx-resizable="{ handles: 'all', minWidth: 100, maxWidth: 700 }">

  <dx-scroll-view data-testid="service-request-dynamic-scroll-view">

    <form #formElement (submit)="onSubmit($event)">

      <dx-form
        data-testid="service-request-dynamic-form"
        id="form"
        class="cards-wide"
        [formData]="requestData"
        [items]="dynamicFormItems()"
        [showValidationSummary]="true"
        [colCount]="dynamicFormConfig()?.form.colCount ?? 2"
        (onInitialized)="onFormInitialized($event)"
        validationGroup="formGroup">

        <!-- Request type selector — always rendered above the dynamic fields -->
        <dxi-item
          [colSpan]="dynamicFormConfig()?.form.colCount ?? 2"
          labelMode="static"
          dataField="requestType"
          editorType="dxSelectBox"
          cssClass="dx-widget"
          [editorOptions]="{
            items: requestTypes,
            valueExpr: 'name',
            displayExpr: 'name',
            required: true,
            searchMode: 'contains',
            searchEnabled: true,
            onSelectionChanged: onRequestTypeSelectionChanged,
            disabled: isEditable
          }">
          <dxo-label text="Request Type" />
          <dxi-validation-rule type="required" message="Request Type is required" />
        </dxi-item>

        <!-- Loan amount grid widget template -->
        <div *dxTemplate="let data of 'loanAmountGridTemplate'">
          <app-loan-amount-grid
            data-testid="service-request-dynamic-loan-amount-grid"
            [config]="getLoanAmountGridConfig(data.name)"
            [dataSources]="dynamicFormConfig()?.dataSources"
            [formContext]="requestData"
            [showInactiveLoans]="showInactiveLoans"
            [value]="requestData[data.name]"
            (valueChange)="onLoanAmountValueChange(data.name, $event)">
          </app-loan-amount-grid>
        </div>

        <!-- File upload widget template -->
        <div *dxTemplate="let data of 'fileUploadTemplate'">
          <app-file-upload
            data-testid="service-request-dynamic-file-upload"
            labelText=""
            [selectButtonText]="getFileUploadConfig(data.name)?.selectButtonText ?? 'Browse or drop files here'"
            [accept]="getFileUploadConfig(data.name)?.accept ?? '*'"
            [multiple]="getFileUploadConfig(data.name)?.multiple ?? true"
            [existingFileUrls]="isEditable ? (task?.parentUrls ?? []) : []"
            (onFileUploadEventEmitter)="onFileUpload($event)"
            (onFileRemoveEventEmitter)="onFileRemove($event)">
          </app-file-upload>
        </div>

        <!-- Display-only label/value widget template -->
        <div *dxTemplate="let data of 'displayLabelTemplate'">
          <div class="display-request-value" data-testid="service-request-dynamic-display-label">
            <span class="display-request-value__label">{{ getDisplayLabelConfig(data.name)?.label ?? '' }}:</span>
            <span class="display-request-value__value">{{ requestData[data.name] ?? '' }}</span>
          </div>
        </div>

      </dx-form>

      <dx-load-panel
        data-testid="service-request-dynamic-load-panel"
        container=".cards-wide"
        [position]="{ of: '.content' }"
        [visible]="isLoading"
        [showPane]="true">
      </dx-load-panel>

    </form>

  </dx-scroll-view>

</div>
